export const SERVICE = {
  ENTERPRISE_PORTAL: 'ENTERPRISE_PORTAL',
  DX_DIAGNOSIS: 'DX_DIAGNOSIS',
  ONLINE_COMMUNITY: 'ONLINE_COMMUNITY',
} as const;

export type ServiceType = (typeof SERVICE)[keyof typeof SERVICE];
